import axios from 'axios';
import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    advancegroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/advance/advancegroup");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
    },
    trxlist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'periode', 'DimCol', 'DimVal', 'kodeacc', 'namaacc', 'uraian', 'nomor', 'jenisAdv','reversed'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/advanaccru${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    trxnotaccrued(obj) {
        return new Promise(async (resolve, reject) => {
            try { 
                const url = `/advanaccru/unaccrued/${moment(obj.tanggal).format('YYYY-MM-DD')}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
    ,
    trxsave(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data }= await axios.post("advanaccru", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
    ,
    trxupdate(obj) {
        // console.log(obj);
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put("advanaccru", obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
    ,
    trxremove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`advanaccru/${obj.advAccruKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = [ 'sortBy', 'sortDir', 'periode', 'DimCol', 'DimColInfo', 'DimVal', 'kodeacc', 'namaacc', 'uraian', 'nomor', 'jenisAdv','reversed'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/advanaccru/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'advance_accrued.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    // printjv(obj = {}) {
    //     return new Promise(async (resolve, reject) => {
    //         let url;
    //         let str = '';
    //         try {
    //             str = '?key=' + encodeURIComponent(obj.advAccruKey);
    //             url = `/advanaccru/printjv`;

    //             url += str;
    //             const { data } = await axios.get(url);
    //             const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
    //             resolve(link);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url ;
            let str = '';
            try {
                const keys = ['nomor', 'tanggal', 'kodejurnal'];
                str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                url = `/buku/printjv`;
                 url += str;
                const { data } = await axios.get(url);
    
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
            });
    },
    getcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`coa/getcoa/${obj.tahun}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    

};